<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>
      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد SMS
        </b-button>
      </b-col>
    </b-row>
    <div v-if="admins">

      <b-card body-class="p-0" class="mt-1">
        <table-head
            ref="adminsTableHeadComponent"
            :items="tableHeadings"
            @sort="sort"
        />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="admin in admins"
            :key="admin.id"
        >
          <b-col class="d-flex align-items-center pl-0" v-if="admin.title">
            {{ admin.title }}
          </b-col>
          <b-col class="d-flex align-items-center" v-if="admin.user_name">
            {{ admin.user_name }}
          </b-col>
          <b-col class="d-flex align-items-center" v-if="admin.guest_number">
            {{ admin.guest_number }} نفر
          </b-col>
          <b-col class="d-flex align-items-center" v-if="admin.host_name">
            {{ admin.host_name }}
          </b-col>
          <b-col class="d-flex align-items-center" v-if="admin.price">
            <strong class="text-success">
              {{ formatnumber(admin.price) }}
            </strong>
            تومان
          </b-col>
          <b-col
              class="d-flex align-items-center flex-row-reverse"
              style="direction: ltr"
          >
            {{ new Date(admin.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
          <b-col class="d-flex align-items-center">
            ---------
<!--            <b-button
                @click="showConfirmModal(admin)"
                variant="flat-danger"
                class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>-->
<!--            <b-button
                @click="showFormModal(admin)"
                variant="flat-secondary"
                class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>-->
          </b-col>
        </b-row>
      </b-card>
      <pagination
          ref="adminsPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="700px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش SMS" : "ایجاد SMS" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class=" mb-3">
<!--        <div>
          برای ارسال هر sms طبق دسته بندی خودش ارسال کنید همانند آنچیزی که دستی sms ارسال میگردید !
        </div>-->
        <b-form-group class="mt-3">
          <label for="admin_user" class="text-capitalize"> انتخاب مهمان :</label>
<!--          <div class="my-1">لطفا اگه مهمانی وجود ندارد آن را بعنوان کاربر ثبت کنید ( صبر کنید تا کاربران کامل لود شود)</div>-->
          <b-form-input v-if="editMode" disabled v-model="adminInput.full_name"></b-form-input>
          <v-select
              v-if="!editMode"
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="adminInput.user_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.full_name"
              :reduce="(user) => user.id"
              :options="users"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ full_name, mobile }">
              {{ full_name }}
              <br />
              <cite>{{ mobile }}</cite>
            </template>
          </v-select>
        </b-form-group>

          <b-form-group>
            <label for="host" class="text-capitalize">
              انتخاب میزبان :<span class="text-danger">*</span></label
            >
<!--            <div class="my-1">لطفا اگه میزبانی وجود ندارد آن را بعنوان میزبان ثبت کنید ( صبر کنید تا میزبان ها کامل لود شود)</div>-->
            <v-select
                id="host"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="adminInput.host_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="owners"
                label="full_name"
                :reduce="(owner) => owner.id"
            />
          </b-form-group>
        <b-form-group>
          <label for="title" class="text-capitalize"
          > عنوان خدمات (مجمتع سام 1 ، پارک آبی و..) <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.title"
              id="title"
              key="title1"
              placeholder="عنوان خدمات"
          />
        </b-form-group>
        <b-form-group>
          <label for="start_date" class="text-capitalize"
          > تاریخ شروع یا اجرا (فعلا بصورت دستی بنویسید طبق الگوی 1402-10-06) <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.start_date"
              id="start_date"
              key="start_date1"
              placeholder="02-06-1402"
          />
        </b-form-group>

        <b-form-group>
          <label for="end_date" class="text-capitalize"
          > تاریخ پایان (فعلا بصورت دستی بنویسید طبق الگوی 1402-10-02) <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.end_date"
              id="end_date"
              key="end_date1"
              placeholder="10-06-1402"
          />
        </b-form-group>

        <b-form-group>
          <label for="duration" class="text-capitalize"
          > مدت زمان اقامت یا اجرا  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.duration"
              id="duration"
              key="duration1"
              placeholder="2"
          />
        </b-form-group>

        <b-form-group>
          <label for="guest_number" class="text-capitalize"
          > تعداد نفرات  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.guest_number"
              id="guest_number"
              key="guest_number1"
              placeholder="2"
          />
        </b-form-group>
        <b-form-group>
          <label for="sans" class="text-capitalize"
          >انتخاب سانس ( آقایان/بانوان نسبت به نوع رزرو)  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.sans"
              id="sans"
              key="sans1"
              placeholder="آقایان"
          />
        </b-form-group>
        <b-form-group>
          <label for="price" class="text-capitalize"
          >هزینه تسویه حساب با میزبان :  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              :formatter="formatnumber"
              v-model="adminInput.price"
              id="price"
              key="price1"
              placeholder="2"
          />
        </b-form-group>

        <b-form-group>
          <label for="payment_price_site" class="text-capitalize"
          >مبلغ پرداختی به سایت ، فقط برای مهمان(در صورتی که وجود ندارد 0 وارد نمایید) :  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              :formatter="formatnumber"
              v-model="adminInput.payment_price_site"
              id="payment_price_site"
              key="payment_price_site1"
              placeholder="0"
          />
        </b-form-group>

        <b-form-group>
          <label for="payment_price" class="text-capitalize"
          >هزینه پرداختی در محل (در صورتی که وجود ندارد 0 وارد نمایید) :  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              :formatter="formatnumber"
              v-model="adminInput.payment_price"
              id="payment_price"
              key="payment_price1"
              placeholder="0"
          />
        </b-form-group>



        <b-form-group>
          <label for="address" class="text-capitalize"
          >آدرس خدمات :  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="adminInput.address"
              id="address"
              key="address1"
              placeholder="آدرس"
          />
        </b-form-group>



        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            انتخاب دسته بندی :<span class="text-danger">*</span>
          </label>
          <div> انتخاب دسته که sms برای آن خدمات ارسال میگردد. </div>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="adminInput.type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="types"
          />
        </b-form-group>



        <b-button block class="float-center" v-if="editMode" @click="submitForm('changePermission')" variant="primary">
          ارسال sms
        </b-button>
      </b-container >
      <hr v-if="editMode" />
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ImageCropper from "@/components/ImageCropper.vue";
import StorageService from "@/services/storage";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ImageCropper,
    BFormRadio
  },
  data() {
    return {
      submitLoading: false,
      userData: null,
      selectedFilter: [],
      isSearchResult:false,
      searchBasesubmitLoading:false,
      avatarCroppedImage: null,
      avatar: null,
      nationalCardCroppedImage: null,
      national_code_image: null,
      nationalCodeImg: null,
      showModal: false,
      modalType: "",
      perPage: 10,
      page: 1,
      users: [],
      owners: [],
      admins: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "عنوان",
          slug: "title",
          sortable: true,
        },
        {
          title: "نام مهمان",
          slug: "last_name",
          sortable: true,
        },
        {
          title: "تعداد نفرات",
          slug: "last_name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "mobile",
          sortable: true,
        },
        {
          title: "هزینه",
          slug: "price",
          sortable: true,
        },
        {
          title: "تاریخ ارسال",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      usersCancelToken: undefined,
      types: [
        "اقامتگاه",
        "تجربه",
        "تور",
        "ترانسفر",
      ],
      adminInput: {
        id: "",
        user_id: "",
        host_id: "",
        start_date: "",
        end_date: "",
        duration: "",
        guest_number:"",
        sans: "",
        price: "",
        payment_price: "",
        payment_price_site: "",
        type:"",
        address:""
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getUrlParams();

    this.getAdminSms();
    this.getUsers();
    this.getOwners();
    this.userData = StorageService.getUserData();
    if (!this.userData) {
      StorageService.setToken("");
      StorageService.setUserData("");
      return this.$router.push({ path: "/login" }).catch(() => {});
    }
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getAdminSms();
    },
    perPage(value) {
      this.page = 1;
      this.getAdminSms();
    },
    page(value) {
      this.getAdminSms();
    },
  },
  methods: {
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },

    getUrlParams() {
      if ("filter[name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[name]`];
        this.selectedFilter.push("name");
      }
      if ("filter[email]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[email]`];
        this.selectedFilter.push("email");
      }
      if ("filter[mobile]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[mobile]`];
        this.selectedFilter.push("mobile");
      }
      if ("per_page" in this.$route.query) {
        this.perPage =Number(this.$route.query[`per_page`]);
        console.log("this.userPerPageComponent", this.$refs.userPerPageComponent);
        this.$refs.userPerPageComponent.perPage=this.perPage
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }
      console.log("this.selectedFilter", this.selectedFilter);
    },
    searchBase(data) {
      console.log("data", data);
      this.selectedFilter=[]
      if (data.selectedFilter.length > 0) {
        data.selectedFilter.forEach((item) => {
          if (item == "name") {
            this.searchInput = data.searchInput;
          } else if (item == "mobile") {
            this.searchInput = data.searchInput;
          } else if (item == "email") {
            this.searchInput = data.searchInput;
          }
        });
        this.selectedFilter=data.selectedFilter
      }
      this.searchBasesubmitLoading=true
      if(this.searchInput){
        this.isSearchResult=true
      }
      if(data.type=='delete'){
        this.isSearchResult=false
      }
      this.getAdminSms();
    },




    async getOwners() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  "filter[name]": this.selectedFilter.includes("name")
        //     ? this.searchInput
        //     : "",
        //   "filter[email]": this.selectedFilter.includes("email")
        //     ? this.searchInput
        //     : "",
        //   "filter[mobile]": this.selectedFilter.includes("mobile")
        //     ? this.searchInput
        //     : "",
        per_page: 5000,
        //   page: this.page,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/host",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.owners = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getAdminSms();
    },

    async getAdminSms() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };

      const requestData = {
        method: "get",
        url: "/admin/admin_sms",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.admins = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(admin) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف SMS مطمئن هستید ؟  : ${admin.title} ${admin.last_name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let adminIndex = 0;
              this.admins = await this.admins.filter((adminItem, index) => {
                if (adminItem.id == admin.id) {
                  adminIndex = index;
                }
                return adminItem.id !== admin.id;
              });

              const requestData = {
                method: "delete",
                url: `/admin/admin_sms/${admin.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `SMS: ${admin.title} ${admin.last_name} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.admins.splice(adminIndex, 0, admin);
                  });
            }
          });
    },
    showFormModal(admin) {
      if (admin) {
        this.adminInput = {
          id: admin.id,
          user_id: admin.id,
          password: "",
          password_confirmation: "",
          permissions:this.filteredPermision(admin.permissions),
          full_name:admin.full_name,
          title:admin.title,
          last_name:admin.last_name,
          gender:admin.gender,
          email:admin.email,
          mobile:admin.mobile

        };
        this.editMode = true;
      } else {
        this.adminInput = {
          id: "",
          user_id: "",
          password: "",
          password_confirmation: "",
        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    updateuserinfo(){
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.adminInput.mobile) {
        errorMessage = "لطفا موبایل sms را وارد کنید";
      }
      if (!errorMessage && !this.adminInput.title) {
        errorMessage = "لطفا نام sms را وارد کنید";
      }
      if (!errorMessage && this.adminInput.title.length < 2) {
        errorMessage = "نام sms نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.adminInput.last_name) {
        errorMessage = "لطفا نام خانوادگی sms را وارد کنید";
      }

      if (!errorMessage && this.adminInput.last_name.length < 2) {
        errorMessage = "نام  خانوادگی sms نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.adminInput.mobile) {
        errorMessage = "لطفا شماره موبایل sms را وارد کنید";
      }
      if (!errorMessage && !this.validateMobile()) {
        errorMessage = "لطفا شماره موبایل صحیح وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;
      let formData=new FormData()
      if(this.adminInput.user_id){
        formData.append("user_id", this.adminInput.user_id);}
      if(this.adminInput.host_id){
        formData.append("host_id", this.adminInput.host_id);}
      if(this.adminInput.title){
        formData.append("title", this.adminInput.title);}
      if(this.adminInput.start_date){
        formData.append("start_date", this.adminInput.start_date);}
      if(this.adminInput.end_date){
        formData.append("end_date", this.adminInput.end_date);}
      if(this.adminInput.duration){
        formData.append("duration", this.adminInput.duration);}
      if(this.adminInput.guest_number){
        formData.append("guest_number", this.adminInput.guest_number);}
      if(this.adminInput.sans){
        formData.append("sans", this.adminInput.sans);}
      if(this.adminInput.price){
        formData.append("price", this.adminInput.price);}
      if(this.adminInput.payment_price){
        formData.append("payment_price", this.adminInput.payment_price);}
      if(this.adminInput.payment_price_site){
        formData.append("payment_price_site", this.adminInput.payment_price_site);}
      if(this.adminInput.type){
        formData.append("type", this.adminInput.type);}
      if(this.adminInput.address){
        formData.append("address", this.adminInput.address);}
      const requestData = {
        method: "post",
        url:  `/admin/admin_sms/${this.adminInput.id}`,
        data: formData,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "sms با موفقیت اضافه شد";
            if (this.editMode) message = "sms با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });

    /*        if (!this.editMode && this.users && this.users.length > 0) {
              this.$refs.usersPaginationComponent.clear();
              this.$refs.usersSearchComponent.clear();
              this.$refs.usersTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }*/

            this.submitLoading = false;
            this.formModal = false;
            this.getAdminSms();
          })
      /*    .catch((err) => {
            let message = "خطا در ایجاد sms";
            if (this.editMode) message = "خطا در ویرایش sms";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });*/
      console.log("updatedata")

      this.submitLoading = false;
      this.formModal = false;
      this.getAdminSms();
    },
    submitForm(type) {
      if(this.editMode && type!=='changePermission'){
        this.updateuserinfo()
        return
      }
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.adminInput.user_id) {
        errorMessage = "لطفا یک sms را انتخاب کنید";
      }
      // if (!errorMessage && !this.adminInput.password) {
      //   errorMessage = "لطفا رمز را وارد کنید";
      // }
      // if (!errorMessage && this.adminInput.password.length < 8) {
      //   errorMessage = "رمز نمی تواند کمتر از 8 کاراکتر باشد";
      // }
      // if (!errorMessage && !this.adminInput.password_confirmation) {
      //   errorMessage = "لطفا تکرار رمز را وارد کنید";
      // }
      // if (
      //   !errorMessage &&
      //   this.adminInput.password != this.adminInput.password_confirmation
      // ) {
      //   errorMessage = "رمز و تکرار رمز یکسان نیستند";
      // }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: "post",
        url:  `/admin/admin_sms`,
        data: this.adminInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "SMS با موفقیت اضافه شد";
            if (this.editMode) message = "SMS با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.users && this.users.length > 0) {
              this.$refs.adminsPaginationComponent.clear();
              this.$refs.adminsSearchComponent.clear();
              this.$refs.adminsTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getAdminSms();
          })

        /*  .catch((err) => {
            let message = "خطا در ایجاد SMS";
            if (this.editMode) message = "خطا در ویرایش SMS";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });*/

      this.submitLoading = false;
      this.formModal = false;
      this.getAdminSms();
    },
    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    validateMobile() {
      return String(this.adminInput.mobile)
          .toLowerCase()
          .match(
              /\+989([0-9]{9})/

          );
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
